const utils = {
  debounce(fn, interval = 1000) {
    let timer = null;
    return function() {
      clearTimeout(timer);
      let context = this;
      let args = arguments;
      timer = setTimeout(function() {
        fn.call(context, ...args);
      }, interval);
    };
  },
  throttle(fn, interval = 1000) {
    let enterTime = 0; //触发的时间
    return function() {
      let context = this;
      let backTime = new Date(); //第一次函数return即触发的时间
      if (backTime - enterTime > interval) {
        fn.call(context, ...arguments);
        enterTime = backTime; //赋值给第一次触发的时间，这样就保存了第二次触发的时间
      }
    };
  },
};
export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js